import useCart from 'src/hooks/use-cart';
import useUI from 'src/hooks/use-ui';
import useSearchPreferences from 'src/hooks/use-search-preferences';
import usePaths from 'src/hooks/use-paths';

import { OnSaveLocationSettings } from 'src/components/location-settings-popover';
import { OrderTypes } from 'state/search-preferences';
import { useAttemptSaveLocationSettings } from './use-attempt-save-location-settings';
import { GlobalHeaderRefs, useGlobalHeaderRefs } from './use-global-header-refs';

type UseGlobalHeaderReturn = GlobalHeaderRefs & {
  itemCount: number;
  address?: string | null;
  orderType: OrderTypes;
  toggleCartView: () => void;
  href: string;
  route: string;
  toggleLocationSettingsDropdown: () => void;
  onSaveLocationSettings: OnSaveLocationSettings;
};

export function useGlobalHeader(): UseGlobalHeaderReturn {
  const { itemCount, formattedAddressShort: address } = useCart();
  const { showCartDrawer, closeCartDrawer, openCartDrawer, toggleLocationSettingsDropdown } = useUI();
  const { orderType } = useSearchPreferences();
  const { href, route } = usePaths({ home: true });
  const {
    cartButtonRef,
    globalHeaderRef,
    addressDropdownContainerRef,
    shopDropdownContainerRef,
  } = useGlobalHeaderRefs();

  const toggleCartView = (): void => (showCartDrawer ? closeCartDrawer() : openCartDrawer());

  const onSaveLocationSettings = useAttemptSaveLocationSettings();

  return {
    cartButtonRef,
    globalHeaderRef,
    addressDropdownContainerRef,
    shopDropdownContainerRef,
    itemCount,
    address,
    orderType,
    toggleCartView,
    toggleLocationSettingsDropdown,
    href,
    route,
    onSaveLocationSettings,
  };
}
